export type ChatAttachmentType = 'beat' | 'verse';

export interface ConversationSummary {
  conversation_id: string;
  peer_id: string;
  peer_username: string;
  peer_role: string;
  peer_state: string | null;
  last_message_at: string;
  last_message_body: string | null;
  last_message_sender_id: string | null;
  last_message_attachment_type: ChatAttachmentType | null;
  unread_count: number;
}

export interface ChatMessage {
  id: string;
  conversation_id: string;
  sender_id: string;
  body: string | null;
  attachment_type: ChatAttachmentType | null;
  attachment_id: string | null;
  created_at: string;
  read_at: string | null;
}

/** Lightweight beat/verse info resolved for rendering attachment cards. */
export interface ChatAttachmentPreview {
  id: string;
  type: ChatAttachmentType;
  title: string;
  subtitle: string;
  /** Route to open the underlying content. */
  href: string;
}

export interface ShareableItem {
  id: string;
  type: ChatAttachmentType;
  title: string;
  subtitle: string;
}

export const ARTIST_ROLES = ['producer', 'rapper', 'producer_rapper'] as const;

export function isArtistRole(role?: string | string[] | null): boolean {
  if (!role) return false;
  const roles = Array.isArray(role) ? role : [role];
  return roles.some(r => (ARTIST_ROLES as readonly string[]).includes(r));
}

export function formatChatRole(role?: string | null): string {
  if (role === 'producer_rapper') return 'Producer & Rapper';
  if (role === 'producer') return 'Producer';
  if (role === 'rapper') return 'Rapper';
  return role || '';
}
